import { createSlice } from '@reduxjs/toolkit';
import set from 'lodash/set';
import toPath from 'lodash/toPath';
const retrievalSlice = createSlice({
    name: 'retrieval',
    initialState: {},
    reducers: {
        setRetrievalValue: (state, action) => {
            set(state, toPath(action.payload.name), action.payload.value);
            return state;
        }
    },
});
export const {
    setRetrievalValue,
} = retrievalSlice.actions;
export default retrievalSlice.reducer;